import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, of} from 'rxjs';
import {catchError, map, shareReplay, tap} from 'rxjs/operators';
import {EnvironmentService} from 'services';

@Injectable({
  providedIn: 'root'
})
export class EsimDevicesService {

  private fallbackDevicesUrl = `/assets/esim_device.json`;
  private cachedDevices$: Observable<any>;

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {}

  getEsimCompatibleDevices(): Observable<any> {
    if (this.cachedDevices$) {
      return this.cachedDevices$;
    }

    const headers = new HttpHeaders({
      Accept: 'application/json',
    });

    const s3BaseUrl = this.environmentService.getAwsS3Url();
    const primaryUrl = s3BaseUrl ? `${s3BaseUrl}/assets/esim_device.json` : this.fallbackDevicesUrl;

    this.cachedDevices$ = this.http.get(primaryUrl, { headers }).pipe(
      catchError(error => {
        console.warn('Errore nel caricamento da URL primario:', primaryUrl, error);
        if (s3BaseUrl && primaryUrl !== this.fallbackDevicesUrl) {
          console.warn('Tentativo di fallback al file locale...');
          return this.http.get(this.fallbackDevicesUrl, { headers }).pipe(
            catchError(fallbackError => {
              console.error('Errore anche nel fallback:', fallbackError);
              this.cachedDevices$ = null;
              return of({ brands: [] });
            })
          );
        } else {
          this.cachedDevices$ = null;
          return of({ brands: [] });
        }
      }),
      tap(data => {
        console.warn('Dispositivi eSIM caricati con successo da:', primaryUrl);
      }),
      shareReplay(1)
    );

    return this.cachedDevices$;
  }

  reloadDevices(): Observable<any> {
    this.cachedDevices$ = null;
    return this.getEsimCompatibleDevices();
  }

  getDataSource(): string {
    const s3BaseUrl = this.environmentService.getAwsS3Url();
    return s3BaseUrl ? 'AWS S3' : 'Local Assets';
  }
}
